import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";
import { StuSignStatus, StuSignStatusMap } from "API/signIn";

interface SignStatusProps {
    state: StuSignStatus;
}

export default function SignStatus({ state }: SignStatusProps) {
    const classMap: { [key: string]: string } = {
        "1": style.Idle,
        "2": style.Done,
        "3": style.Timeout
    };

    return (
        <span className={classNames(style.root, classMap[state])}>
            {StuSignStatusMap[state]}
        </span>
    );
}
